import { Component, computed, inject } from '@angular/core';
import { LoadingWidgetDataService } from './loading-widget-data.service';

@Component({
    selector: 'adminui-loading-widget',
    imports: [],
    templateUrl: './loading-widget.component.html'
})
export class LoadingWidgetComponent {

  private readonly loadingWidgetDataService = inject(LoadingWidgetDataService);

  counter = this.loadingWidgetDataService.counter;
  show = computed(() => this.counter() > 0);
}
